import React from "react";
import HowItWorks from "../components/HowItWorks";

const HowItWorksPage = () => {
  return <HowItWorks />;
};

export default HowItWorksPage;
